// 라벨이 컴포넌트로 넘어 올 경우 타이틀 처리
export const getOptionTitle = label => {
    if (typeof label === 'object') {
        return label?.props?.title ?? '';
    }
    return label;
};
